import React, {useEffect, useState} from 'react';
import '../App.css';
import { Form } from 'react-bootstrap';
import { Button } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import Axios from 'axios';
import { Hint } from 'react-autocomplete-hint';
import Bodyheaderloged from './bodyheaderloged'
import Grillaboticket from './grillaboticket'

function Bodygestiontickets (props){
    const [hintDataCliente, setHintDataCliente] = useState([])
    const [hintDataBeneficiario, setHintDataBeneficiario] = useState([])
    const [text, setText] = useState('')
    const [text2, setText2] = useState('')
    const [rut, setRut] = useState()
    const [rut2, setRut2] = useState()
    const [fecha, setFecha] = useState()
    const [alertActivateSuccess, setAlertActivateSuccess] = useState(false);
    const [alertActivateDanger, setAlertActivateDanger] = useState(false);
    const [alertActivateWarning, setAlertActivateWarning] = useState(false);

    const getDataClientes = async () => {
        const res = await Axios.get(process.env.REACT_APP_URLUSERGET)
          var hintArray = []
           res.data.usuarios.map(a => hintArray.push(a.rut))
           setHintDataCliente(hintArray)
    }

    const getDataBeneficiarios = async () => {
        const res = await Axios.get(process.env.REACT_APP_URLBENEFICIARIOSBYUSER,{
            params:{
                rut:rut
            },
            headers: {
                'Access-Control-Allow-Origin' : '*',
                'Access-Control-Allow-Methods': 'GET, POST',
                'Access-Control-Allow-Headers': 'Content-Type'
            }})
          var hintArray = []
           res.data.beneficiarios.map(a => hintArray.push(a.rut))
           setHintDataBeneficiario(hintArray)
    }

    const handlerFecha = async (e) =>{
        setFecha(e.target.value)
    }

    const handlerRutCliente = async (e) =>{
        setText(e.target.value)
        setRut(e.target.value)
    }

    const handlerRutCliente2 = async (e) =>{
        setText2(e.target.value)
        setRut2(e.target.value)
    }    

    const handlerBlurRutCliente2 = async (e) =>{
        setRut2(e.target.value)
    }

    const handlerBlurRutCliente = (e) =>{
        setRut(e.target.value)
        if(rut.length == 10)
        {
            getDataBeneficiarios()
        }
    }

    const createConsumoManual = async () =>{
        if(rut != ''){
            if(rut2 != '')
            {
                if(fecha != 'undefined')
                {
                    const data = {
                        tickets:[{
                            rutcliente:rut,
                            rutbeneficiario:rut2,
                            fechaconsumo:fecha
                            }
                        ]
                    }
                    const res = await Axios.post(process.env.REACT_APP_URLCREATECONSUMO, data,{
                        headers: {
                            'Access-Control-Allow-Origin' : '*',
                            'Access-Control-Allow-Methods': 'GET, POST',
                            'Access-Control-Allow-Headers': 'Content-Type'
                        }})
                    if (res.data.MessageCode == "0")
                    {
                        setText('')
                        setText2('')
                        setRut('')
                        setRut2('')
                        setFecha('')
                        setAlertActivateSuccess(true)
                        setTimeout(() => {
                            setAlertActivateSuccess(false)
                        }, 5000)
                    }
                    else
                    {
                        setAlertActivateDanger(true)
                        setTimeout(() => {
                            setAlertActivateDanger(false)
                        }, 5000)
                    }
                }
                else
                {
                    setAlertActivateWarning(true)
                    setTimeout(() => {
                        setAlertActivateWarning(false)
                    }, 5000)                        
                }
            }
            else
            {
                setAlertActivateWarning(true)
                setTimeout(() => {
                    setAlertActivateWarning(false)
                }, 5000)
            }
        }
        else{
            setAlertActivateWarning(true)
            setTimeout(() => {
                setAlertActivateWarning(false)
            }, 5000)
        }
    }

    useEffect(() => {
        getDataClientes()
    }, []);

    return (
        <div className='w-full'>
            <div className='flex justify-start w-full'>
                <Bodyheaderloged mailloginP={props.mailloginP} apptokenP={props.apptokenP} setStateMailP={props.setStateMailP}/>
            </div>

            <div className='flex justify-start w-full'>
                <Grillaboticket/>
            </div>
        </div>
                 
    )
}
export default Bodygestiontickets